import { render, staticRenderFns } from "./profitItem.vue?vue&type=template&id=5258c759&scoped=true&"
import script from "./profitItem.vue?vue&type=script&lang=js&"
export * from "./profitItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5258c759",
  null
  
)

export default component.exports